interface SvgProps {
  width: number;
  height: number;
}

function VisaIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Visa">
      <rect width="38" height="24" rx="3" fill="#1A1F71" />
      <text
        x="19" y="17"
        textAnchor="middle"
        fill="white"
        fontSize="12"
        fontWeight="800"
        fontFamily="Arial, Helvetica, sans-serif"
        letterSpacing="1"
        fontStyle="italic"
      >
        VISA
      </text>
    </svg>
  );
}

function MastercardIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Mastercard">
      <rect width="38" height="24" rx="3" fill="#252525" />
      <circle cx="15" cy="12" r="7" fill="#EB001B" />
      <circle cx="23" cy="12" r="7" fill="#F79E1B" opacity="0.93" />
    </svg>
  );
}

function AmexIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="American Express">
      <rect width="38" height="24" rx="3" fill="#016FD0" />
      <text
        x="19" y="10.5"
        textAnchor="middle"
        fill="white"
        fontSize="6.5"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
        letterSpacing="0.4"
      >
        AMERICAN
      </text>
      <text
        x="19" y="19"
        textAnchor="middle"
        fill="white"
        fontSize="6.5"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
        letterSpacing="0.4"
      >
        EXPRESS
      </text>
    </svg>
  );
}

function DiscoverIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Discover">
      <rect width="38" height="24" rx="3" fill="white" stroke="#E0E0E0" strokeWidth="0.75" />
      <text
        x="7" y="15.5"
        fill="#231F20"
        fontSize="7"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
        letterSpacing="-0.2"
      >
        DISCOVER
      </text>
      <circle cx="31" cy="12" r="6" fill="#F76F20" />
    </svg>
  );
}

function JcbIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="JCB">
      <rect width="38" height="24" rx="3" fill="white" stroke="#E0E0E0" strokeWidth="0.75" />
      <rect x="7" y="4" width="8" height="16" rx="3" fill="#003087" />
      <rect x="15.5" y="4" width="8" height="16" rx="3" fill="#CC0000" />
      <rect x="24" y="4" width="8" height="16" rx="3" fill="#009A44" />
      <text x="11" y="15" textAnchor="middle" fill="white" fontSize="7" fontWeight="700" fontFamily="Arial, sans-serif">J</text>
      <text x="19.5" y="15" textAnchor="middle" fill="white" fontSize="7" fontWeight="700" fontFamily="Arial, sans-serif">C</text>
      <text x="28" y="15" textAnchor="middle" fill="white" fontSize="7" fontWeight="700" fontFamily="Arial, sans-serif">B</text>
    </svg>
  );
}

function DinersIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Diners Club">
      <rect width="38" height="24" rx="3" fill="white" stroke="#E0E0E0" strokeWidth="0.75" />
      <circle cx="16" cy="12" r="7.5" stroke="#004B97" strokeWidth="1.5" />
      <circle cx="22" cy="12" r="7.5" stroke="#004B97" strokeWidth="1.5" />
    </svg>
  );
}

function UnionPayIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="UnionPay">
      <rect width="38" height="24" rx="3" fill="white" stroke="#E0E0E0" strokeWidth="0.75" />
      <rect x="4" y="4" width="10" height="16" rx="2.5" fill="#CC0000" />
      <rect x="12" y="4" width="10" height="16" rx="2.5" fill="#CC0000" />
      <rect x="20" y="4" width="10" height="16" rx="2.5" fill="#007A3D" />
      <rect x="28" y="4" width="7" height="16" rx="2.5" fill="#003087" />
      <text x="9" y="15" textAnchor="middle" fill="white" fontSize="6" fontWeight="700" fontFamily="Arial, sans-serif">UP</text>
    </svg>
  );
}

function BankIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Bank account">
      <rect width="38" height="24" rx="3" fill="#1E293B" />
      <path d="M19 5.5 L29 10 L9 10 Z" fill="white" />
      <rect x="11.5" y="11" width="2.2" height="6.5" fill="white" />
      <rect x="16" y="11" width="2.2" height="6.5" fill="white" />
      <rect x="20.5" y="11" width="2.2" height="6.5" fill="white" />
      <rect x="25" y="11" width="2.2" height="6.5" fill="white" />
      <rect x="9" y="18.2" width="20" height="2" rx="0.5" fill="white" />
    </svg>
  );
}

function ZelleIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Zelle">
      <rect width="38" height="24" rx="3" fill="#6D1ED4" />
      <rect x="18" y="3.5" width="2" height="17" rx="1" fill="white" />
      <path
        d="M13 8 H25 V10 L16.5 17 H25 V19.5 H13 V17.5 L21.5 10.5 H13 Z"
        fill="white"
      />
    </svg>
  );
}

function LinkIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Link">
      <rect width="38" height="24" rx="3" fill="#00D66F" />
      <path d="M15.5 6.5 L22 12 L15.5 17.5" stroke="#011E0F" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function GenericCardIcon({ width, height }: SvgProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Card">
      <rect width="38" height="24" rx="3" fill="#6B7280" />
      <rect x="4" y="8" width="30" height="3.5" fill="white" opacity="0.6" />
      <rect x="4" y="15" width="9" height="2.5" rx="1" fill="white" opacity="0.45" />
      <rect x="15" y="15" width="9" height="2.5" rx="1" fill="white" opacity="0.45" />
    </svg>
  );
}

export function CardBrandIcon({
  brand,
  size = 28,
}: {
  brand: string | null | undefined;
  size?: number;
}) {
  const width = Math.round(size * (38 / 24));
  const props: SvgProps = { width, height: size };

  switch (brand?.toLowerCase()) {
    case 'visa':
      return <VisaIcon {...props} />;
    case 'mastercard':
      return <MastercardIcon {...props} />;
    case 'amex':
      return <AmexIcon {...props} />;
    case 'discover':
      return <DiscoverIcon {...props} />;
    case 'jcb':
      return <JcbIcon {...props} />;
    case 'diners':
    case 'diners_club':
      return <DinersIcon {...props} />;
    case 'unionpay':
      return <UnionPayIcon {...props} />;
    case 'link':
      return <LinkIcon {...props} />;
    default:
      return <GenericCardIcon {...props} />;
  }
}

/**
 * Brand-aware icon for any payment method type (card / bank / zelle).
 * Renders the real card-brand mark for cards, a bank glyph for ACH, and the
 * Zelle mark for Zelle — all sharing the same card-shaped 38×24 footprint so
 * rows align cleanly.
 */
export function PaymentMethodIcon({
  type,
  brand,
  size = 28,
}: {
  type: 'card' | 'bank_account' | 'zelle';
  brand?: string | null;
  size?: number;
}) {
  const width = Math.round(size * (38 / 24));
  const props: SvgProps = { width, height: size };

  if (type === 'zelle') return <ZelleIcon {...props} />;
  if (type === 'bank_account') return <BankIcon {...props} />;
  return <CardBrandIcon brand={brand} size={size} />;
}
